import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class UserDialogService {
  currentStageProgress = new BehaviorSubject(null);
  currentSubscriptionProgress = new BehaviorSubject(null);

  setStage(stage: string): void {
    this.currentStageProgress.next({ stage });
  }

  setSubscriptionProgress(progress: string): void {
    this.currentSubscriptionProgress.next({ progress });
  }
}
